/** A message for the sign-in page that has to survive a reload (Clerk's sign-out navigates). */
export const NOTICE_KEY = "clientflow.signInNotice";
